type FloatingThemeSwitcherPolicy = {
  isDevelopment: boolean;
  isExtensionRuntime: boolean;
  isQa: boolean;
};

export const shouldShowFloatingThemeSwitcher = ({
  isDevelopment,
  isExtensionRuntime,
  isQa,
}: FloatingThemeSwitcherPolicy): boolean =>
  isDevelopment || (!isExtensionRuntime && isQa);
